exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-634acd44] .el-form-item{margin-bottom:0!important}", ""]);

// exports
